import React from 'react';

type FineprintIconType =
	| 'affirm'
	| 'error'
	| 'featured'
	| 'help'
	| 'information'
	| 'sparkle'
	| 'warning';

type FineprintProps = {
	text?: string;
	type?: FineprintIconType;
	children?: React.ReactNode;
	className?: string;
	dataqa?: string;
};

export default function Fineprint({
	text,
	type,
	children,
	className,
	dataqa,
}: FineprintProps) {
	return (
		<div
			className={`common-ui-fineprint ${className || ''}`}
			{...(dataqa && { 'data-qa': dataqa })}
		>
			{type && <i className={type} aria-label={type} />}
			{children ? (
				<div className="text">{children}</div>
			) : (
				text && <span className="text">{text}</span>
			)}
		</div>
	);
}
